import { safeSocket2Fetch } from './ZionServer.ts'

export interface SessionCapacity {
  current: number
  max: number
  open: boolean
  remaining: number
}

/** GET /session/capacity — offline/timeout → null (non blocca UI). */
export async function fetchSessionCapacity(): Promise<SessionCapacity | null> {
  try {
    const res = await safeSocket2Fetch('/session/capacity', {
      headers: { Accept: 'application/json' },
    })
    if (!res || !res.ok) return null
    const text = await res.text()
    if (!text.trim()) return null
    let data: SessionCapacity
    try {
      data = JSON.parse(text) as SessionCapacity
    } catch {
      return null
    }
    if (typeof data.max !== 'number') return null
    return data
  } catch {
    return null
  }
}
